module.exports = __webpack_public_path__ + "static/media/about-certificate-img8.2d263896.jpg";